/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as RepoStrongRef from "../../../com/atproto/repo/strongRef.defs.js";

const $nsid = "place.stream.media.defs";

export { $nsid };

/** A collection of tracks representing the canonical source of a video. */
type SourceTracks = { $type?: "place.stream.media.defs#sourceTracks";

  /**
   * The canonical list of tracks specifying the source of a video.
   */
  "tracks":(RepoStrongRef.Main)[] };

export type { SourceTracks };

/** A collection of tracks representing the canonical source of a video. */
const sourceTracks = /*#__PURE__*/ l.typedObject<SourceTracks>($nsid, "sourceTracks", /*#__PURE__*/ l.object({"tracks":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<RepoStrongRef.Main>((() => RepoStrongRef.main) as any), )}));

export { sourceTracks };

/** An object representing that this video's source is a clip from another video. */
type SourceClip = { $type?: "place.stream.media.defs#sourceClip";

  /**
   * AT URI of the video we're clipping.
   */
  "video":l.AtUriString;

  /**
   * Start time of the clip in milliseconds.
   */
  "start":number;

  /**
   * End time of the clip in milliseconds.
   */
  "end":number };

export type { SourceClip };

/** An object representing that this video's source is a clip from another video. */
const sourceClip = /*#__PURE__*/ l.typedObject<SourceClip>($nsid, "sourceClip", /*#__PURE__*/ l.object({"video":/*#__PURE__*/ l.string({"format":"at-uri"}),"start":/*#__PURE__*/ l.integer(),"end":/*#__PURE__*/ l.integer()}));

export { sourceClip };

/** A track backed by a MUXL container */
type MuxlTrack = { $type?: "place.stream.media.defs#muxlTrack";

  /**
   * BLAKE-3 content hash (BDASL CID) of the source video segment.
   */
  "blob":string;

  /**
   * Size in bytes of the source video segment.
   */
  "size"?:number;

  /**
   * ID of the track within the MUXL container. 1-indexed for MP4 reasons.
   */
  "trackId":string;

  /**
   * Type of the track: video, audio, or text.
   */
  "mediaType":string;

  /**
   * Language of the track, if applicable.
   */
  "language"?:string;

  /**
   * did:key of the ephemeral key that C2PA-signed this track's segments. The private key is discarded once the track is produced, so it can only ever have signed this content.
   */
  "signingKey"?:l.DidString };

export type { MuxlTrack };

/** A track backed by a MUXL container */
const muxlTrack = /*#__PURE__*/ l.typedObject<MuxlTrack>($nsid, "muxlTrack", /*#__PURE__*/ l.object({"blob":/*#__PURE__*/ l.string(),"size":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"trackId":/*#__PURE__*/ l.string(),"mediaType":/*#__PURE__*/ l.string(),"language":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"signingKey":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"did"}))}));

export { muxlTrack };
